module.exports = __webpack_public_path__ + "img/fleetify_logo.53fe0eac.png";